import { balloon1x, balloon2x, balloon3x } from 'images/landingpages/health_insurance';
import { Amount, Button, Headline, Paragraph } from 'Common';
import { AccessibilityLink } from 'Component';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getZppCertifiedSubscriptionPlan } from 'redux/query';
import { linkHandler } from 'utils/linkHandler';
import { TEXT } from 'locales/translations';
import Style from './HealthInsuranceCooperationBox.style';
import { replacePlaceholder } from 'utils/replacePlaceholder';

export const HealthInsuranceCooperationBox = ({ insuranceCompany, insuranceOffer, courseType = 'sda' }) => {
  const history = useHistory();
  const plan = useSelector(getZppCertifiedSubscriptionPlan({ course: courseType })) ?? {};

  const forwardToPage = () => {
    const url = linkHandler.get('healthInsuranceCooperationCourse', { cooperation: insuranceCompany.slug, course: insuranceOffer.slug });
    history.push(url + '#anmeldung-krankenkasse');
  };

  return (
    <Style id="section-checkout-box" className="px-5 py-5 px-md-4 px-lg-5 d-flex flex-column align-items-center mx-auto mt-5 mt-md-0">
      <img
        className="img_balloon_checkout_dak d-block"
        srcSet={`${balloon1x} 165w, ${balloon2x} 330w, ${balloon3x} 495w`}
        src={balloon1x}
        alt="Balloon umsonst"
      />
      <Headline level={4} className="mb-0">
        {insuranceOffer.title}
      </Headline>
      <Paragraph>
        {replacePlaceholder('inkl. {{contentAccessDuration}} Monate Balloon', {
          contentAccessDuration: insuranceOffer.contentAccessDuration
        })}
      </Paragraph>
      <Amount className="h1" value={0} currency={plan.currency} />
      <Paragraph className="plans-btn-kk__interval mb-2 align-self-center strike_price">
        <Amount value={plan.chargeAmount} currency={plan.currency} />
      </Paragraph>
      <div className="text-center">
        <Button className="mt-auto" color="green" onClick={forwardToPage}>
          Jetzt kostenlos starten
        </Button>
      </div>

      <div className="info-text mt-4 px-3 px-md-0">
        <Paragraph className="extra-small">
          {TEXT.resiliencePage.refundBox.asteriskText}
          <br />
          Zu den <AccessibilityLink />
        </Paragraph>
      </div>
    </Style>
  );
};
